<!--Back Button-->
<div class="container">
  <div class="d-none d-lg-block pt-3">
    <button class="back-btn border-0 d-flex align-items-center justify-content-center" [routerLink]="'/rewards/raffles'">
      <span class="material-icons text-white">arrow_back_ios_new</span>
    </button>
  </div>
</div>

<!--Point Summary Bar-->
<div class="container">
  <fgb-points-summary-bar [backButtonLink]="'/rewards/raffles'" [backButtonTitle]="'Raffles'"></fgb-points-summary-bar>
</div>

<!--Lotto Details-->
<fgbcl-lotto-details-v2 [lottoId]="id" />
